import { Link } from "react-router-dom";

const getSafeFinishUrl = (finishUrl) => {
    const trimmedFinishUrl = finishUrl?.trim();

    if (!trimmedFinishUrl) {
        return "";
    }

    try {
        const parsedUrl = new URL(trimmedFinishUrl);

        return parsedUrl.protocol === "https:" ? parsedUrl.href : "";
    } catch {
        return "";
    }
};

function FightCard({fight}) {
    const isRedWinner = fight?.winner_fighter_name === fight?.red_corner_fighter_name;
    const isBlueWinner = fight?.winner_fighter_name === fight?.blue_corner_fighter_name;
    const finishUrl = getSafeFinishUrl(fight?.finish_url);
    const finishButtonClass = isRedWinner
        ? "fight-finish-button fight-finish-button--red"
        : isBlueWinner
            ? "fight-finish-button fight-finish-button--blue"
            : "fight-finish-button fight-finish-button--neutral";
    const divisionWeightLbs = fight?.division_weight_lbs;
    const hasDivisionWeight = divisionWeightLbs !== null
        && divisionWeightLbs !== undefined
        && String(divisionWeightLbs).trim() !== "";

    return (
        <div className="card fight-card mb-3">
            <div className="card-body p-3">
                <div className="row align-items-center g-2">
                    <div className="col-auto">
                        <div
                            style={{
                                width: "6px",
                                height: "24px",
                                backgroundColor: "red",
                                borderRadius: "2px",
                            }}
                        ></div>
                    </div>
                    <div className="col-12 col-md-4 text-start">
                        <span className="fw-semibold">
                            <Link to={`/fighter/${fight?.red_corner_fighter_id}`}>
                                {fight?.red_corner_fighter_name}
                            </Link>
                            {isRedWinner && <span className="badge bg-danger ms-2 fight-winner-badge">WINNER</span>}
                        </span>
                    </div>
                    <div className="col-12 col-md-3 text-start text-body-secondary">
                        {fight?.method}
                    </div>
                    <div className="col-12 col-md-3 text-start text-body-secondary">
                        {fight?.division_name}
                        {hasDivisionWeight && <> - {divisionWeightLbs} lbs</>}
                    </div>
                </div>
                <hr />
                <div className="row align-items-center g-2">
                    <div className="col-auto">
                        <div
                            style={{
                                width: "6px",
                                height: "24px",
                                backgroundColor: "blue",
                                borderRadius: "2px",
                            }}
                        ></div>
                    </div>
                    <div className="col-12 col-md-4 text-start">
                        <span className="fw-semibold">
                            <Link to={`/fighter/${fight?.blue_corner_fighter_id}`}>
                                {fight?.blue_corner_fighter_name}
                            </Link>
                            {isBlueWinner && <span className="badge bg-primary ms-2 fight-winner-badge">WINNER</span>}
                        </span>
                    </div>
                    <div className="col-12 col-md-3 text-start text-body-secondary text-nowrap">
                        {fight?.round ? `Round ${fight.round}` : null}
                        {fight?.round && fight?.time_str ? " · " : null}
                        {fight?.time_str || null}
                    </div>
                    <div className="col-12 col-md-3 d-flex align-items-center gap-2 justify-content-md-start">
                        {fight?.potn_fighter_name && (
                            <span className={`badge bg-${fight?.potn_fighter_name === fight?.red_corner_fighter_name ? 'danger' : 'primary'} fight-award-badge`}>
                                POTN
                            </span>
                        )}
                        {fight?.fotn && <span className="badge bg-primary fight-award-badge">FOTN</span>}
                        {finishUrl && (
                            <a
                                href={finishUrl}
                                className={finishButtonClass}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`Watch finish for ${fight?.red_corner_fighter_name} vs ${fight?.blue_corner_fighter_name}`}
                            >
                                WATCH FINISH
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FightCard;
